import { styled, Box, Grid } from "@mui/material";

//
// INFORMATION FORM
//
export const InformationFormContainer = styled(Box)(({ theme }) => ({
  width: "40vw",

  [theme.breakpoints.down("sm")]: {
    width: "80%"
  }
}));

export const InformationTabsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "8px",

  "& button.MuiTab-root": {
    display: "flex",
    width: "220px",
    height: "48px",
    padding: "8px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "6px",
    border: "1px solid var(--gray-200, #EFF4FF)",
    background: "#FFF",

    [theme.breakpoints.down("sm")]: {
      width: "134px",
      height: "48px",
      marginRight: "20px"
    }
  },

  "& button.MuiTab-root.Mui-selected": {
    border: "1px solid var(--brand-primary-500, #00B2A3)",
    background: "var(--brand-primary-100, #F5FFFE)",
    color: "var(--gray-900, #1D1F2B);"
  },

  "& .MuiTabs-indicator": {
    display: "none"
  },

  ">div>div": {
    margin: "0px"
  }
}));

export const InformationTabHeading = styled("p")({
  color: "var(--gray-700, #323946)",
  fontFamily: "Gilroy",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "112%"
});

//
// PAYMENT FORM
//
export const PaymentFormContainer = styled(Grid)(({ theme }) => ({
  "& h5": {
    color: "var(--gray-900, #1D1F2B)",
    fontFamily: "Gilroy",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "115%"
  },

  ".css-1uc33dm": {
    fontSize: "10px"
  },

  "& .MuiTypography-root": {
    color: "#000",
    fontFamily: "Gilroy",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "115%"
  }
}));

export const TermsHeading = styled("h5")({
  color: "#1D1F2B",
  fontFamily: "Gilroy",
  fontWeight: `500 !important`,
  lineHeight: "115%",
  marginLeft: "-16px",
  fontSize: "20px"
});

export const MainHeading = styled("h5")({
  color: "#1D1F2B",
  fontFamily: "Gilroy",
  fontWeight: `500 !important`,
  lineHeight: "115%",
  marginLeft: "-16px",
  fontSize: "20px"
});

export const LabelText = styled("p")({
  color: "#000000",
  fontFamily: "Gilroy",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "13.8px",
  marginLeft: "-16px"
});

// The tenant's own colour, not Allsetra's: these links sit next to the consent
// statements, and a whitelabel deployment showed them in Allsetra teal.
export const LabelLinkText = styled("a")(({ theme }) => ({
  color: theme.palette.primary.main,
  fontFamily: "Gilroy",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "13.8px",
  textDecoration: "underline",
  margin: "0px 4px"
}));

export const CheckBoxContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  "&:hover": {
    cursor: "pointer"
  }
});

//
// PAYMENT METHOD SELECTION
//
export const PaymentMethodOption = styled("button", {
  shouldForwardProp: (prop) => prop !== "isSelected"
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  all: "unset",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
  width: "100%",
  padding: "16px",
  borderRadius: "6px",
  border: isSelected
    ? "1px solid var(--brand-primary-500, #00B2A3)"
    : "1px solid var(--gray-200, #EFF4FF)",
  background: isSelected ? "var(--brand-primary-100, #F5FFFE)" : "#FFF",
  cursor: "pointer",
  textAlign: "left",

  "&:hover": {
    border: "1px solid var(--brand-primary-500, #00B2A3)"
  },

  // The whole row is the control, so keyboard focus has to stay visible.
  "&:focus-visible": {
    outline: "2px solid var(--brand-primary-500, #00B2A3)",
    outlineOffset: "2px"
  },

  [theme.breakpoints.down("sm")]: {
    padding: "12px"
  }
}));

export const PaymentMethodRadio = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected"
})<{ isSelected: boolean }>(({ isSelected }) => ({
  flexShrink: 0,
  width: "18px",
  height: "18px",
  marginTop: "2px",
  borderRadius: "50%",
  border: isSelected ? "5px solid #00B2A3" : "1px solid #C4CBD8",
  background: "#FFF",
  boxSizing: "border-box"
}));

export const PaymentMethodName = styled("p")({
  color: "var(--gray-900, #1D1F2B)",
  fontFamily: "Gilroy",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "115%",
  margin: 0
});

export const PaymentMethodDescription = styled("p")({
  color: "#76848F",
  fontFamily: "Gilroy",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "140%",
  margin: "4px 0 0 0"
});

export const PaymentMethodHint = styled("p")({
  color: "#76848F",
  fontFamily: "Gilroy",
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "140%",
  margin: 0
});

export const PaymentMethodNotice = styled(Box)({
  padding: "12px 16px",
  borderRadius: "6px",
  border: "1px solid var(--gray-200, #EFF4FF)",
  background: "#F8FAFC",

  "& p": {
    color: "#323946",
    fontFamily: "Gilroy",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "140%",
    margin: 0
  }
});
